import axios from 'axios';
import type {
  BasicContact,
  JsonObject,
  ParsedAppointment,
} from '@bb/domain/dist/types';
import type { AppointmentDoc } from '@bb/domain/dist/schemas';

export type BookAppointmentResponse = Omit<
  ParsedAppointment,
  'userId' | 'userName' | 'coop'
> & {
  retsId: string;
  uid: string;
  coop: BasicContact;
};

const bookAppointment = async (
  appointment: JsonObject<
    Pick<
      AppointmentDoc,
      | 'type'
      | 'listingId'
      | 'notify'
      | 'recordAppointment'
      | 'note'
      | 'date'
      | 'time'
      | 'timeEnd'
      | 'buyers'
    > &
      (
        | { coop: AppointmentDoc['coop'] }
        | {
            coop: Record<string, never>;
            customContact: AppointmentDoc['customContact'];
          }
      )
  >,
  timeRestrictionsOverridden?: boolean,
) => {
  const config = {
    url: `/listing/${appointment.listingId!}/appointments`,
    method: 'POST',
    data: appointment,
  };
  if (timeRestrictionsOverridden) {
    const search = new URLSearchParams({
      override: String(timeRestrictionsOverridden),
    });
    config.url += `?${search.toString()}`;
  }

  const { data } =
    await axios.request<JsonObject<BookAppointmentResponse>>(config);

  return data;
};

export default bookAppointment;
